/**
 * Map the send-grant columns of a workflow definition row to the UI shape.
 *
 * A grant is a standing permission for this workflow to send without asking, so
 * the thing the user must be able to read at a glance is *who it reaches* —
 * that is what the grant binds, and what editing the workflow revokes.
 */
export function sendGrantFromRow(row = {}) {
  const grant = row.send_grant
  if (!grant || !Array.isArray(grant.actions) || grant.actions.length === 0) return null
  return {
    grantedAt: row.send_grant_at ?? null,
    expiresAt: grant.expires_at ?? null,
    maxSendsPerRun: Number(grant.max_sends_per_run ?? 0),
    actions: grant.actions.map((action) => ({
      toolSlug: String(action?.tool_slug ?? ''),
      recipients: Object.entries(action?.principal ?? {}).map(
        ([field, values]) => `${field}: ${[].concat(values).join(', ')}`,
      ),
    })),
  }
}
